// src/pages/NotFound.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocumentTitle';
import './NotFound.css';

export default function NotFound() {
  useDocumentTitle('Page not found', 'This page does not exist.');

  return (
    <section className="not-found page-container">
      <p className="not-found-code">404</p>
      <h1>Page not found</h1>
      <p className="tagline">The page you’re looking for doesn’t exist or has moved.</p>
      <Link to="/" className="btn primary">Back to Home</Link>
    </section>
  );
}
